module.exports = __webpack_public_path__ + "img/bigger.0404414d.svg";